// extracted by mini-css-extract-plugin
module.exports =  {"textArea":"jut__TextAreaField__textArea","textAreaReadOnly":"jut__TextAreaField__textAreaReadOnly"};